import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { TabMenu } from "primereact/tabmenu";
import showToast from "../Toast";
import { useAuth } from "../../utils/UserProvider";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { User } from "../../interfaces";
import { MultiSelect } from "primereact/multiselect";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../../config/awsParams";

const FormAddActif = ({
  setSelectedInterlocuteur,
  setSelectedOptionsSociete,
  setSelectedOptionsIndividu,
  setSelectedFile,
  setAddedActif,
  addedActif,
  closeModalActif,
  openModal,
  selectedFile,
  optionsinterlocuteur,
  selectedInterlocuteur,
  optionsSociete,
  selectedOptionsSociete,
  optionsIndividu,
  selectedOptionsIndividu,
}) => {
  const [picture, setPicture] = useState(addedActif?.file);
  const [activeIndex, setActiveIndex] = useState(0);
  const { user, client } = useAuth();
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const isAdminOrMaitreAdmin = () =>
    user &&
    (user.role.includes("MAITRE_ADMIN_CLIENT") ||
      user.role.includes("ADMIN_CLIENT"));

  const isGexpertise = () =>
    user &&
    (user.role.includes("ADMIN_GEXPERTISE") ||
      user.role.includes("ASSISTANT_PROJET"));

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: addedActif,
  });

  const handleSelectChangeSociete = (e) => {
    setSelectedOptionsSociete(e.value);
  };
  const handleSelectChangeIndividu = (e) => {
    setSelectedOptionsIndividu(e.value);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0];
    setSelectedFile(URL.createObjectURL(file));
    setPicture(file);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const onSubmit = async (data) => {
    try {
      if (
        ((selectedOptionsSociete && selectedOptionsSociete.length > 0) ||
          (selectedOptionsIndividu && selectedOptionsIndividu.length > 0)) &&
        selectedInterlocuteur !== null &&
        selectedInterlocuteur !== undefined
      ) {
        let actifData = {};
        if (selectedOptionsIndividu && selectedOptionsIndividu.length) {
          actifData = {
            nom_actif: data.nom_actif,
            individus: selectedOptionsIndividu,
            env_client_id: client.id,
            interlocuteur_referent_id:user.id,
            numero_taxe:data.numero_taxe,

            ...(picture !== null ? { file: picture } : {}),
            ...(data.class_principale_actif !== undefined &&
            data.class_principale_actif !== ""
              ? { class_principale_actif: data.class_principale_actif }
              : {}),
            ...(data.référence_client !== undefined &&
            data.référence_client !== ""
              ? { référence_client: data.référence_client }
              : {}),
          };
        } else {
          actifData = {
            nom_actif: data.nom_actif,
            societes: selectedOptionsSociete,
            env_client_id: client.id,
            interlocuteur_referent_id:user.id,
            numero_taxe:data.numero_taxe,

            ...(picture !== null ? { file: picture } : {}),
            ...(data.class_principale_actif !== undefined &&
            data.class_principale_actif !== ""
              ? { class_principale_actif: data.class_principale_actif }
              : {}),
            ...(data.référence_client !== undefined &&
            data.référence_client !== ""
              ? { référence_client: data.référence_client }
              : {}),
          };
        }
        setAddedActif(actifData);
        closeModalActif();
        openModal("correspondance");
      } else {
        showToast(
          "info",
          "veuillez renseigner un propriétaire et un intérlocuteur"
        );
      }
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  const customTabTemplate = (item) => (
    <button
      type="button"
      onClick={() => {
        setActiveIndex(items.indexOf(item));
      }}
      className={` px-36 rounded-lg  items-center py-2 text-sm font-semibold text-gray-900  border ${
        items.indexOf(item) === activeIndex
          ? "hover:bg-gexpertise-200 hover:text-white   focus:bg-gexpertise-200 focus:text-white"
          : null
      }`}
    >
      {item.label}
    </button>
  );

  const interlocuteurOptionTemplate = (option: User) => {
    return (
      <div className="flex space-x-2">
        <img
          className="object-cover w-8 h-8 rounded-full"
          src={
            option?.photo_user
              ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${option?.photo_user}`
              : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
          }
        />
        <div className="text-left rtl:text-right">
          <h1 className="text-md font-semibold text-gray-700 capitalize ">
            {option?.first_name + " " + option?.last_name}
          </h1>
        </div>
      </div>
    );
  };
  const selectedInterlocuteurTemplate = (option: User, props) => {
    if (option) {
      return (
        <div className="flex space-x-2">
          <img
            className="object-cover w-8 h-8 rounded-full"
            src={
              option?.photo_user
                ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${option?.photo_user}`
                : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
            }
          />
          <div className="text-left rtl:text-right">
            <h1 className="text-md font-semibold text-gray-700 capitalize ">
              {option?.first_name + " " + option?.last_name}
            </h1>
          </div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const items = [
    {
      label: "Société",
      template: customTabTemplate,
    },
    {
      label: "Individu",
      template: customTabTemplate,
    },
  ];

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="grid grid-cols-6 gap-6 mb-2">
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="nom_actif"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Nom *
            </label>
            <input
              type="text"
              name="nom_actif"
              id="nom_actif"
              placeholder="Saisir nom "
              className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("nom_actif", {
                required: true,
              })}
            />
            {errors.nom_actif && (
              <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 mt-2  px-2 py-1 rounded ">
                champs obligatoire
              </span>
            )}
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="picture"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Photo actif
            </label>
            <div className="flex space-x-3 mt-5">
              <div>
                <div className="w-22 h-20">
                  <img
                    src={
                      selectedFile ? selectedFile : "/images/default_actif.png"
                    }
                    alt="Preview"
                    className="w-full h-full rounded-lg object-cover"
                  />
                </div>

                <input
                  type="file"
                  id="picture"
                  name="picture"
                  accept="image/*"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  className="hidden"
                />
              </div>
              <div className="flex flex-col items-center space-y-2 ">
                <button
                  type="button"
                  onClick={handleButtonClick}
                  className="bg-gexpertise-200 hover:bg-gexpertise-100 text-white font-bold py-3 px-6 rounded-xl focus:outline-none focus:shadow-outline"
                >
                  Choisir photo
                </button>
                <span className=" text-center text-xs py-2 font-semibold text-gray-500">
                  PNG, JPG or JPEG (MAX. 800x400px)
                </span>
              </div>
            </div>
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="référence_client"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Référence client
            </label>
            <input
              type="text"
              name="référence_client"
              id="référence_client"
              placeholder="Saisir référence client"
              className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("référence_client")}
            />
          </div>
          <div className="col-span-3 sm:col-span-3">
            <label
              htmlFor="class_principale_actif"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Classe principale d’actif 
            </label>
            <input
              type="text"
              name="class_principale_actif"
              id="class_principale_actif"
              placeholder="Saisir la classe principale"
              className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("class_principale_actif")}
            />
          </div>


          <div className="col-span-6 sm:col-span-6">
            <label
              htmlFor="Numéro d’avis de taxe foncière"
              className="block text-md font-bold leading-6 text-gray-900"
            >
              Numéro de taxe foncière *
            </label>
            <input
              type="text"
              name="numero_taxe"
              id="numero_taxe"
              placeholder="Saisir numéro de taxe foncière"
              className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
              {...register("numero_taxe", {
                required: true,
              })}
            />
          </div>



          {(isGexpertise() || isAdminOrMaitreAdmin()) && (
            <div className="col-span-6 sm:col-span-6">
              <label
                htmlFor="interlocuteur_referent"
                className="block text-md font-bold leading-6 text-gray-900 mb-3"
              >
                Interlocuteur référent *
              </label>

              <Dropdown
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200  w-full"
                value={
                  selectedInterlocuteur
                    ? selectedInterlocuteur
                    : addedActif?.interlocuteur_referent_id
                }
                onChange={(e: DropdownChangeEvent) => {
                  setSelectedInterlocuteur(e.value);
                }}
                options={optionsinterlocuteur}
                optionLabel="name"
                placeholder="Choisir interlocuteur..."
                showClear
                filter
                valueTemplate={selectedInterlocuteurTemplate}
                itemTemplate={interlocuteurOptionTemplate}
              />
            </div>
          )}
        </div>


        






        <div
          className="flex items-center p-4 my-4 text-sm text-blue-800 rounded-lg bg-blue-50 "
          role="alert"
        >
          <svg
            className="flex-shrink-0 inline w-4 h-4 mr-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
          </svg>
          <span className="sr-only">Info</span>
          <div className="text-md">
            <strong>Choisir propriétaire</strong>
          </div>
        </div>

        <div className="border rounded-lg w-full ">
          <TabMenu
            model={items}
            activeIndex={activeIndex}
            onTabChange={(e) => {
              setActiveIndex(e.index);
            }}
            className="flex justify-center w-full"
          />
          {activeIndex === 0 ? (
            <div className="grid grid-cols-6 gap-6 mx-5 my-5">
              <div className="col-span-6 sm:col-span-6">
                <div className="flex space-x-2">
                  <label
                    htmlFor="societe_id"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Choisir société(s) *
                  </label>
                  {(isAdminOrMaitreAdmin() || isGexpertise()) && (
                    <button
                      type="button"
                      onClick={() => {
                        openModal("societe");
                      }}
                      className="px-2 py-2 text-sm  text-white  bg-gexpertise-100 rounded-full  hover:bg-gexpertise-200"
                    >
                      <img src="images/plus.png" alt="plus" />
                    </button>
                  )}
                </div>

                <MultiSelect
                  className="my-3 border border-gray-300 text-gray-900 font-bold text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
                  placeholder="Sélectionner vos sociètes"
                  options={optionsSociete}
                  value={
                    selectedOptionsSociete
                      ? selectedOptionsSociete
                      : addedActif?.societes
                  }
                  onChange={handleSelectChangeSociete}
                  name="id"
                  filter
                  display="chip"
                />
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-6 gap-6 mx-5 my-5">
              <div className="col-span-6 sm:col-span-6">
                <div className="flex space-x-2  ">
                  <label
                    htmlFor="societe_id"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Choisir individu(s) *
                  </label>
                  {(isAdminOrMaitreAdmin() || isGexpertise()) && (
                    <button
                      type="button"
                      onClick={() => {
                        openModal("individu");
                      }}
                      className="px-2 py-2 text-sm  text-white  bg-gexpertise-100 rounded-full  hover:bg-gexpertise-200"
                    >
                      <img src="images/plus.png" alt="plus" />
                    </button>
                  )}
                </div>

                <MultiSelect
                  className="my-3 border border-gray-300 text-gray-900 font-bold text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
                  placeholder="Sélectionner vos individus"
                  options={optionsIndividu}
                  value={
                    selectedOptionsIndividu
                      ? selectedOptionsIndividu
                      : addedActif?.individus
                  }
                  onChange={handleSelectChangeIndividu}
                  name="id"
                  filter
                  display="chip"
                />
              </div>
            </div>
          )}
        </div>
        <p className=" text-lg font-thin my-4">* obligatoire</p>

        <div className="flex justify-end space-x-2 mt-10">
          <button
            type="submit"
            className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
          >
            Suivant
          </button>
          <button
            type="button"
            onClick={() => {
              closeModalActif();
              setSelectedFile(null);
              setSelectedOptionsIndividu([]);
              setSelectedOptionsSociete([]);
              setSelectedInterlocuteur(null);
            }}
            className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-2  text-center "
          >
            Annuler
          </button>
        </div>
      </form>
    </>
  );
};

export default FormAddActif;
